exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shareContext__shareButtonsWrapper___1l-uz {\n  display: flex;\n  flex-direction: row;\n  gap: 12; }\n  .shareContext__shareButtonsWrapper___1l-uz button {\n    transition: 300ms; }\n    .shareContext__shareButtonsWrapper___1l-uz button:hover {\n      filter: brightness(1.15);\n      transform: scale(1.05); }\n", ""]);

// exports
exports.locals = {
	"shareButtonsWrapper": "shareContext__shareButtonsWrapper___1l-uz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/shareContext.scss
// module id = 4477
// module chunks = 6